import useLandaDialogs from 'components/dialogs/hooks/useLandaDialogs';
import { LANDA_DIALOGS } from 'components/dialogs/utils';
import Button from 'components/generics/buttons/Button';
import useHasBankConnection from 'hooks/requests/financials/useHasBankConnection';
import classes from './index.module.scss';

const TotalCashButtons = () => {
  const { openDialog } = useLandaDialogs();
  const { hasBankConnection } = useHasBankConnection();

  return (
    <div className={classes.buttonsContainer}>
      <Button
        onClick={() =>
          hasBankConnection
            ? openDialog(LANDA_DIALOGS.TRANSFER_FUNDS)
            : openDialog(LANDA_DIALOGS.MANUAL_BANK_CONNECT)
        }
        variant={'secondary'}
        className={classes.button}
        // disabled={!hasBankConnection} disable temporary
        title="Temporarily unavailable"
        disabled={true}
      >
        Transfer Funds
      </Button>
    </div>
  );
};

export default TotalCashButtons;
